module.exports = __webpack_public_path__ + "static/mermaid-1-f520e3508301d55520e57376f01302d2.jpg";